import { render, staticRenderFns } from "./yeniProforma.vue?vue&type=template&id=b2ea79ec&scoped=true&"
import script from "./yeniProforma.vue?vue&type=script&lang=js&"
export * from "./yeniProforma.vue?vue&type=script&lang=js&"
import style0 from "./yeniProforma.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./yeniProforma.vue?vue&type=style&index=1&id=b2ea79ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea79ec",
  null
  
)

export default component.exports